import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import styles from "./plan.module.css";

function PlanDetailsTable({ planData }) {
  const [activeKeys, setActiveKeys] = useState(["0"]);
  if (!planData || !Object.keys(planData).length) {
    return <p>No plan details available</p>;
  }

  const handleToggle = (key) => {
    setActiveKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key)
        : [...prevKeys, key]
    );
  };

  const formatCurrency = (amount, currency = "INR") => {
  if (amount === null || amount === undefined) return "--"; 
  return `${currency === "INR" ? "₹" : "$"}${amount}`;
};

  const formatBoolean = (value) => {
    if (value === null || value === undefined) return "--";
    return value ? "Yes" : "No";
  };

  const formatFrequency = (freq) => {
    const frequencies = {
      "MONTHLY": "Monthly",
      "YEARLY": "Yearly",
      "WEEKLY": "Weekly",
      "DAILY": "Daily"
    };
    return frequencies[freq] || freq || "--";
  };
  const formatValue = (val) => (val !== null && val !== undefined ? val : "--");
  return (
    <Accordion activeKey={activeKeys} className={styles.accordionContainer}>
      <Accordion.Item eventKey="0">
        <Accordion.Header
          onClick={() => handleToggle("0")}
          className={styles.accordionHeader}
        >
          Basic Plan Information
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Plan Code:</td>
                <td className={styles.textMuted}>
                  {planData?.code || "--"}
                </td>
              </tr>
              <tr>
                <td>Plan Name:</td>
                <td className={styles.textMuted}>
                  {planData?.name || "--"}
                </td>
              </tr>
              <tr>
                <td>Status:</td>
                <td className={styles.textMuted}>
                  <span className={`${styles.status} ${planData?.status === "ACTIVE" ? styles.statusActive : styles.statusInactive}`}>
                    {planData?.status || "--"}
                  </span>
                </td>
              </tr>
              <tr>
                <td>Currency:</td>
                <td className={styles.textMuted}>
                  {planData?.currencyCd || "--"}
                </td>
              </tr>
              <tr>
                <td>Plan Sequence:</td>
                <td className={styles.textMuted}>
                  {planData?.planSeq || "--"}
                </td>
              </tr>
              <tr>
                <td>Created By:</td>
                <td className={styles.textMuted}>
                  {planData?.createdBy || "--"}
                </td>
              </tr>
              <tr>
                <td>Updated By:</td>
                <td className={styles.textMuted}>
                  {planData?.updatedBy || "--"}
                </td>
              </tr>
              <tr>
                <td>Comment:</td>
                <td className={styles.textMuted}>
                  {planData?.comment || "--"}
                </td>
              </tr>
            </tbody>
          </table>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
        <Accordion.Header
          onClick={() => handleToggle("1")}
          className={styles.accordionHeader}
        >
          Pricing & Fees
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Subscription Amount:</td>
                <td className={styles.textMuted}>
                  {formatCurrency(planData?.subscriptionAmt, planData?.currencyCd)}
                </td>
              </tr>
              <tr>
                <td>Plan Title Amount:</td>
                <td className={styles.textMuted}>
                  {planData?.planTitleAmount ? `${planData.planTitleAmount}` : "--"}
                </td>
              </tr>
               <tr>
                <td>Plan Title Adjacent:</td>
                <td className={styles.textMuted}>
                  {planData?.planTitleAdjacent ? `${planData.planTitleAdjacent}` : "--"}
                </td>
              </tr>
              <tr>
                <td>Account Opening Fees:</td>
                <td className={styles.textMuted}>
                  {formatCurrency(planData?.acctOpenFeesAmt, planData?.currencyCd)}
                </td>
              </tr>
              <tr>
                <td>Trade Commission:</td>
                <td className={styles.textMuted}>
                  {planData?.tradeCommissionAmt ? `$${planData.tradeCommissionAmt}` : "--"}
                </td>
              </tr>
              <tr>
                <td>Share Commission:</td>
                <td className={styles.textMuted}>
                  {planData?.shareCommissionAmt ? `$${planData.shareCommissionAmt}` : "--"}
                </td>
              </tr>
              <tr>
                <td>AUM Commission (%):</td>
                <td className={styles.textMuted}>
                  {planData?.aumCommissionPct ? `${parseFloat(planData.aumCommissionPct).toFixed(3)}%` : "--"}
                </td>
              </tr>
              <tr>
                <td>Minimum Commission:</td>
                <td className={styles.textMuted}>
                  {planData?.minCommissionAmt ? `$${planData.minCommissionAmt}` : "--"}
                </td>
              </tr>
              <tr>
                <td>Fee Description:</td>
                <td className={styles.textMuted}>
                  {planData?.feeDesc || "--"}
                </td>
              </tr>
            </tbody>
          </table>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2" style={{ marginTop: "20px" }}>
        <Accordion.Header
          onClick={() => handleToggle("2")}
          className={styles.accordionHeader}
        >
          Trading Limits & Features
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Order Quantity Limit:</td>
                <td className={styles.textMuted}>
                  {formatValue(planData?.orderQtyLimit)}
                </td>
              </tr>
              <tr>
                <td>Free Trades:</td>
                <td className={styles.textMuted}>
                  {formatValue(planData?.freeTrades)}
                </td>
              </tr>
              <tr>
                <td>Free Trades Quantity:</td>
                <td className={styles.textMuted}>
                   {formatValue(planData?.freeTradesQty)}
                </td>
              </tr>
              <tr>
                <td>Free Trades Frequency:</td>
                <td className={styles.textMuted}>
                  {formatFrequency(planData?.freeTradesFreqCd)}
                </td>
              </tr>
              <tr>
                <td>Strike Price Flag:</td>
                <td className={styles.textMuted}>
                  {formatBoolean(planData?.strikePriceFlg)}
                </td>
              </tr>
              <tr>
                <td>Stock Scope:</td>
                <td className={styles.textMuted}>
                  {planData?.stockScope || "--"}
                </td>
              </tr>
            </tbody>
          </table>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3" style={{ marginTop: "20px" }}>
        <Accordion.Header
          onClick={() => handleToggle("3")}
          className={styles.accordionHeader}
        >
          Plan Settings
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Subscription Plan:</td>
                <td className={styles.textMuted}>
                  {formatBoolean(planData?.subscriptionFlg)}
                </td>
              </tr>
              <tr>
                <td>Plan Override:</td>
                <td className={styles.textMuted}>
                  {formatBoolean(planData?.planOverrideFlg)}
                </td>
              </tr>
              <tr>
                <td>Default Plan:</td>
                <td className={styles.textMuted}>
                  {formatBoolean(planData?.defaultPlanFlg)}
                </td>
              </tr>
            </tbody>
          </table>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4" style={{ marginTop: "20px" }}>
        <Accordion.Header
          onClick={() => handleToggle("4")}
          className={styles.accordionHeader}
        >
          Support Information
        </Accordion.Header>
        <Accordion.Body className={styles.accordionBody}>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Hotline Support Phone:</td>
                <td className={styles.textMuted}>
                  {planData?.hotlineSupportPhone ? (
                    <a
                      href={`tel:${planData.hotlineSupportPhone}`}
                      className={styles.link}
                    >
                      {planData.hotlineSupportPhone}
                    </a>
                  ) : (
                    "--"
                  )}
                </td>
              </tr>
              <tr>
                <td>Hotline Support Text:</td>
                <td className={styles.textMuted}>
                  {planData?.hotlineSupportText || "--"}
                </td>
              </tr>
            </tbody>
          </table>
        </Accordion.Body>
      </Accordion.Item>
      <>
        {planData.planConfig?.some((c) => c.key === "features") && (
          <Accordion.Item eventKey="5" style={{ marginTop: "20px" }}>
            <Accordion.Header
              onClick={() => handleToggle("5")}
              className={styles.accordionHeader}
            >
              Features
            </Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <table className={styles.detailsTable}>
                <thead>
                  <tr>
                    <th className={styles.text}>Type</th>
                    <th className={styles.text}>Text</th>
                    <th className={styles.text}>Tooltip</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={styles.text}>
                      {planData.planConfig.find((c) => c.key === "features")?.value?.type || "--"}
                    </td>
                    <td className={styles.text}>
                      {planData.planConfig.find((c) => c.key === "features")?.value?.text || "--"}
                    </td>
                    <td className={styles.text}>
                      {planData.planConfig.find((c) => c.key === "features")?.value?.toolTips || "--"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {planData.planConfig?.some((c) => c.key === "featuresv2") && (
          <Accordion.Item eventKey="6" style={{ marginTop: "20px" }}>
            <Accordion.Header
              onClick={() => handleToggle("6")}
              className={styles.accordionHeader}
            >
              Features V2
            </Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <table className={styles.detailsTable}>
                <thead>
                  <tr>
                    <th className={styles.text}>Feature Name</th>
                    <th className={styles.text}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={styles.text}>
                      {planData.planConfig.find((c) => c.key === "featuresv2")?.value?.featureName || "--"}
                    </td>
                    <td className={styles.text}>
                      {planData.planConfig.find((c) => c.key === "featuresv2")?.value?.description || "--"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {planData.planConfig?.some((c) => c.key === "tickerCommission") && (
          <Accordion.Item eventKey="7" style={{ marginTop: "20px" }}>
            <Accordion.Header
              onClick={() => handleToggle("7")}
              className={styles.accordionHeader}
            >
              Ticker Commission
            </Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <div style={{ overflowX: "auto" }}>
              <table className={styles.detailsTable}>
                <thead>
                  <tr>
                    <th className={styles.text}>Ticker</th>
                    <th className={styles.text}>Trade Commission</th>
                    <th className={styles.text}>Share Commission</th>
                    <th className={styles.text}>AUM Commission</th>
                    <th className={styles.text}>Min Commission</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {(() => {
                      const value = planData.planConfig.find((c) => c.key === "tickerCommission")?.value || {};
                      return (
                        <>
                          <td className={styles.text}>{value.ticker || "--"}</td>
                          <td className={styles.text}>{value.tradeCommission || "--"}</td>
                          <td className={styles.text}>{value.shareCommission || "--"}</td>
                          <td className={styles.text}>{value.aumCommission || "--"}</td>
                          <td className={styles.text}>{value.minCommission || "--"}</td>
                        </>
                      );
                    })()}
                  </tr>
                </tbody>
              </table>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        )}

        {planData.planConfig && planData.planConfig.length > 0 && (
          <Accordion.Item eventKey="8" style={{ marginTop: "20px" }}>
            <Accordion.Header
              onClick={() => handleToggle("8")}
              className={styles.accordionHeader}
            >
              Other Plan Configurations
            </Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              {Object.entries(
                planData.planConfig
                  .filter((item) =>
                    !["features", "featuresv2", "tickerCommission"].includes(item.key)
                  )
                  .reduce((acc, item) => {
                    const { category } = item;
                    if (!acc[category]) acc[category] = [];
                    acc[category].push(item);
                    return acc;
                  }, {})
              )?.map(([category, configs]) => (
                <div key={category} style={{ marginBottom: "20px" }}>
                  <table className={styles.detailsTable}>
                    <tbody>
                      {configs?.map((config) => (
                        <tr key={config.stoPlanConfigId}>
                          <td>{config.displayName || config.key}:</td>
                          <td className={styles.textMuted}>
                            {(() => {
                              const { key, value } = config;

                              if (key === "premiumFeatures" && value?.feature) {
                                return value.feature;
                              }

                              if (key === "conditionalText" && value?.text) {
                                return value.text;
                              }

                              if (typeof value === "object") {
                                return (
                                  <pre style={{ whiteSpace: "pre-wrap", marginBottom: 0, fontSize: "13px" }}>
                                    {JSON.stringify(value, null, 2)}
                                  </pre>
                                );
                              }

                              return value || "--";
                            })()}
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        )}
      </>

    </Accordion>
  );
}

export default PlanDetailsTable;